<div class="footer">
  <!-- FIN BOTÓN FOOTER ATRÁS -->
  <app-boton-accion-secundaria *ngIf="index>2" (click)="atras()" [id]="'atrás'" [icono]="'hs-arrow-back'" [titulo]="'anterior'"></app-boton-accion-secundaria>
  <!-- BOTÓN FOOTER NUEVO ENVÍO -->
  <app-boton-accion *ngIf="index>1" class="flexRight" [id]="id" [icono]="" [titulo]="titulo" (click)="clicked()"></app-boton-accion>
</div>
